import { InvestmentsProfile } from '@/firebase/index';

export default {
  getAllProfiles() {
    return InvestmentsProfile.get();
  }
};
